<p>quick-attendence works!</p>
